import Navbar from "../components/Navbar/Navbar";
import styles from "../style/home.module.css";
import redArrow from "../assets/image/red-arrow.svg";
import whiteArrow from "../assets/image/white-arrow.svg";
import { ReactComponent as RingSVG } from "../assets/image/ring.svg";
import descriptionImage from "../assets/image/description-photo.webp";
import recapVideo from "../assets/video/documentary.mp4";
import playIcon from "../assets/image/play-button.svg";
import { useRef, useState, useEffect } from "react";
import { ReactComponent as LuthLogo } from "../assets/image/luth-logo.svg";
import { ReactComponent as LsbtcLogo } from "../assets/image/lsbtc-logo.svg";
import { ReactComponent as KbLogo } from "../assets/image/kb-klub-logo.svg";
import { ReactComponent as NbtsLogo } from "../assets/image/nbts-logo.svg";
import { ReactComponent as AisecLogo } from "../assets/image/aieseclogo.svg";
import { ReactComponent as AmsulLogo } from "../assets/image/amsullogo.svg";
import { ReactComponent as JaraLogo } from "../assets/image/jaralogo.svg";
import { ReactComponent as KnowledgeLogo } from "../assets/image/knowledgelogo.svg";
import { ReactComponent as LeoLogo } from "../assets/image/leologo.svg";
import { ReactComponent as NimelssaLogo } from "../assets/image/nimelssalogo.svg";
import { ReactComponent as NuessaLogo } from "../assets/image/nuesalogo.svg";
import { ReactComponent as NunsaLogo } from "../assets/image/nunsalogo.svg";
import { ReactComponent as RedcrossLogo } from "../assets/image/redcrosslogo.svg";
import { ReactComponent as UlapsLogo } from "../assets/image/ulapslogo.svg";
import { ReactComponent as UlesLogo } from "../assets/image/uleslogo.svg";
import blackArrow from "../assets/image/black-arrow.svg";
import Footer from "../components/Footer/Footer";
import { Link } from "react-router-dom";
import { bloodDriveLocations } from "../data/bloodDriveLocations";

const Home = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handlePause = () => {
    videoRef.current.pause();
    setIsPlaying(false);
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      setIsPlaying(false);
    };

    video.addEventListener("ended", handleEnded);

    return () => {
      video.removeEventListener("ended", handleEnded);
    };
  }, []);

  const heroBackgroundImages = [
    "/assets/background-Image/hero-background-1.webp",
    "/assets/background-Image/hero-background-2.webp",
    "/assets/background-Image/hero-background-3.webp",
  ];

  useEffect(() => {
    heroBackgroundImages.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPrevIndex(currentIndex);
      setCurrentIndex((prev) => (prev + 1) % heroBackgroundImages.length);
    }, 12000); // change every 12 seconds

    return () => clearInterval(interval); // cleanup
  }, [currentIndex]);

  return (
    <div className="home">
      {/*    NAV   */}

      <Navbar isRegistrationPage={false} />

      {/* HERO */}

      <div className={`${styles.heroSection} hero-section`} key={currentIndex}>
        <div
          className={styles.heroSectionBefore}
          s
          style={{
            backgroundImage: `url(${heroBackgroundImages[prevIndex]})`,
          }}
        ></div>
        <div
          className={styles.heroSectionAfter}
          style={{
            backgroundImage: `url(${heroBackgroundImages[currentIndex]})`,
            opacity: 1,
            transform: "translateX(0)",
          }}
        ></div>

        <div className={styles.heroDescription}>
          <h3 className={styles.heroDescriptionTitle}>
            Your Power to Gift Life 2.0
          </h3>

          <div className={styles.mottoLayout}>
            <h3 className={styles.mottoHead}>One Lagos, One Mission:</h3>
            <h3 className={styles.mottoBody}>
              Save{" "}
              <span>
                10,000
                {/* <img src={ringSVG} alt="ring" /> */}
                <RingSVG className={styles.ringSVG} />
              </span>{" "}
              Lives
            </h3>
          </div>

          <p className={styles.mandate}>
            Join thousands of people across {bloodDriveLocations.length} LGAs in
            Lagos on August 15th,2025 as we donate blood, restore hope, and give
            life. Your donation could be the reason someone survives.
          </p>

          <div className={styles.heroBtnLayout}>
            <Link to="/register">
              <button className={styles.registerBtn}>
                Register as a Donor
              </button>
            </Link>
            <Link to="/finalstats">
              <button className={styles.partnerBtn}>
                Check Final Stats <img src={redArrow} alt="arrow" />
              </button>
            </Link>
          </div>
        </div>
        <div className={styles.redOverlay}></div>
      </div>

      {/* DESCRIPTION      */}

      <section className={styles.descriptionSectionLayout}>
        <div className={styles.description1Layout}>
          <h3 className={styles.description1Header}>
            Every Drop Counts, Every Life Matters
          </h3>
          <p className={styles.description1Text}>
            Every day in Nigeria, thousands of lives are lost due to the
            unavailability of safe blood. According to the World Health
            Organization, Nigeria needs at least 2 million units of blood
            annually — yet less than half is donated. Your decision to donate
            can be the difference between life and death.
          </p>
        </div>
        <div className={styles.description2Layout}>
          <img
            src={descriptionImage}
            alt=""
            className={styles.description2Image}
            loading="lazy"
          />
          <div className={styles.description2Description}>
            <h3 className={styles.description2Header}>
              Together, We can Change that
            </h3>
            <p className={styles.description2Text}>
              This is more than a blood drive — it's a movement of compassion
              and collective impact. You can support by:
              <ul className={styles.description2TextList}>
                <li>Donating Blood – Be a hero for someone in need.</li>
                <li>
                  Spread the Word – Amplify our message across your network
                </li>
                <li>
                  Sponsor the Cause – Support logistics, welfare, and outreach
                  with voluntary donations or services.
                </li>
              </ul>
            </p>
            <Link to="/register">
              <button className={styles.descriptionRegisterButton}>
                Register Now
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* PURPOSE       */}

      <section className={styles.purposeSectionLayout}>
        <div className={styles.purposeDescription}>
          <h3>Why we do this</h3>
          <p>
            This isn’t just another campaign—it’s about real lives, real
            stories, and real impact. Watch the journey from Your Power to Gift
            Life (YPTGL) 1.0 and discover why this mission matters now more than
            ever.
          </p>
        </div>
        <div className={styles.purposeVideo}>
          <video src={recapVideo} ref={videoRef}></video>
          {!isPlaying && (
            <div className={styles.wrapper}>
              <button onClick={handlePlay} className={styles.playButton}>
                <img src={playIcon} alt="playIcon" /> Watch Recap
              </button>
            </div>
          )}
          {isPlaying && (
            <div className={styles.wrapper} onClick={handlePause}></div>
          )}
        </div>

        <a
          href="https://drive.google.com/file/d/1kCMuGv9ISadw-irXPK1OuQdMO2piwVKX/view"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className={styles.purposeDownloadButton}>
            Download YPTGL 1.0 Post Event Report{" "}
            <img src={whiteArrow} alt="arrow" />
          </button>
        </a>
      </section>

      {/* LOCATION        */}

      <section className={styles.locationSection}>
        <div className={styles.locationSectionDescription}>
          <h3 className={styles.locationSectionHeader}>
            Find a Donation Venue Near You
          </h3>
          <p className={styles.locationSectionDescriptionText}>
            Across {bloodDriveLocations.length} LGAs in Lagos, we’re bringing
            the opportunity to give life closer to you. Find the center closest
            to you and take part in this life-saving initiative.
          </p>
        </div>

        {/* NEXT TIME JUST STORE THE DATA IN AN ARRAY AND LOOP OVER IT */}

        <table className={styles.locationTableDesktop}>
          <colgroup>
            <col style={{ width: "25%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "50%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>Location</th>
              <th>Venue Name</th>
              <th> Location</th>
            </tr>
          </thead>
          <tbody>
            {bloodDriveLocations.map((location) => (
              <tr key={location.id}>
                <td>{location.lga}</td>
                <td>{location.venue}</td>
                <td>{location.address}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <table className={styles.locationTableMobile}>
          <colgroup>
            <col style={{ width: "35%" }} />
            <col style={{ width: "65%" }} />
          </colgroup>
          <thead>
            <tr>
              <th>Location</th>
              <th>Venue Name & Location</th>
            </tr>
          </thead>
          <tbody>
            {bloodDriveLocations.map((location) => (
              <tr key={location.id}>
                <td>{location.lga}</td>
                <td>
                  <p className={styles.venue}>{location.venue}</p>
                  {location.address}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/*  GALLERY */}
      <section className={styles.gallerySection}>
        <div className={`${styles.galleryPhoto} ${styles.galleryPhotoTop}`}>
          <div
            className={styles.image}
            style={{
              backgroundImage: "url('/assets/gallery-photo-2.webp')",
            }}
          ></div>
        </div>
        <div className={styles.galleryPhotosBottom}>
          <div className={styles.galleryPhoto}>
            <div
              className={styles.image}
              style={{
                backgroundImage: "url('/assets/gallery-photo-1.webp')",
              }}
            ></div>
          </div>
          <div className={styles.galleryPhoto}>
            <div
              className={styles.image}
              style={{
                backgroundImage: "url('/assets/gallery-photo-3.webp')",
              }}
            ></div>
          </div>
        </div>
      </section>

      {/*    PARTNERS    */}
      <section className={styles.partnerSection}>
        <div className={styles.partnerSectionDescription}>
          <h3>Partner With Us</h3>
          <p>
            This life-saving mission is made possible by the incredible support
            of our partner organizations who believe in the power of community
            impact.
          </p>
          <div className={styles.logoLayout}>
            <LuthLogo className={styles.img} />
            <LsbtcLogo className={styles.img} />
            <KbLogo className={styles.img} />
            <NbtsLogo className={styles.img} />
            <AisecLogo className={styles.img} viewBox="0 0 1265 259" />
            <AmsulLogo className={styles.img} viewBox="0 0 1080 1080" />
            <JaraLogo className={styles.img} viewBox="0 0 1080 1080" />
            <KnowledgeLogo className={styles.img} viewBox="0 0 731 958" />
            <NimelssaLogo className={styles.img} viewBox="0 0 400 400" />
            <NuessaLogo className={styles.img} viewBox="0 0 510 510" />
            <NunsaLogo className={styles.img} viewBox="0 0 203 220" />
            <RedcrossLogo className={styles.img} viewBox="0 0 736 743" />
            <UlapsLogo className={styles.img} viewBox="0 0 1154 1087" />
            <UlesLogo className={styles.img} viewBox="0 0 1890 1890" />
            <LeoLogo className={styles.img} viewBox="0 0 1080 1080" />
          </div>
          <p>
             We’re always looking to build with more value-driven brands. If
            your organization is passionate about health, humanity, or community
            development, let’s collaborate.
          </p>
        </div>
        <a
          href="mailto:kbklubcmul@gmail.com?subject=Partnership%20for%20Your%20Power%20to%20gift%20life%202.0"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className={styles.partnerButton}>
            Partner with Us <img src={blackArrow} alt="" />
          </button>
        </a>
      </section>

      {/* FOOTER */}

      <Footer></Footer>
    </div>
  );
};

export default Home;
